module.exports = __webpack_public_path__ + "static/img/cont64 (2).909e144.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont64 (2).jpg
// module id = uWRv
// module chunks = 0